import Vue from "vue";
import Router from "vue-router";

import { store } from "../main.js";

import Home from "./home";
import Login from "./login";
import User from "./user";
import Role from "./role";
import Shift from "./shift";
import Team from "./team";
import Profile from "./profile";
import ThemeCategory from "./theme_category";
import Theme from "./theme";
import Schedule from "./schedule";
import Event from "./event";
import AreasTurnos from "./areasturnos"
import CheckUser from "./checkUser";
import Parameters from "./parameters";

Vue.use(Router);

const router = new Router({
    mode: "history",
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        User,
        Role,
        Shift,
        Team,
        Profile,
        ThemeCategory,
        Theme,
        Schedule,
        Event,
        AreasTurnos,
        CheckUser,
        Parameters
    ]
});

router.beforeEach((to, from, next) => {
    const authenticated = localStorage.getItem("token");

    if (!authenticated && to.path.toString() != "/login") {
        next("/login");

        return true;
    }

    if (authenticated && to.path.toString() == "/login") {
        next("/");

        return true;
    }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === "Home") {
        _name = "";
        _route = "";
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js